import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/villages/selectVillage',
            name: 'villages_selectVillage',
            component: () => import("./views/selectVillage.vue"),
            meta: {
            }
        },
    ];
};